module.exports = __webpack_public_path__ + "static/img/Logo Talmud_Search_Blue_Circle.bc1da23a.png";